import { DiffitBooksProvider } from '../Homepage/Contexts/DiffitBooksContext';
import { UnlimitedModalsProvider } from './contexts/UnlimitedModalsContext';
import { UnlimitedProvider, useUnlimitedContext } from './contexts/UnlimitedContext';
import { UnlimitedMainView } from './UnlimitedMainView';
import { UnlimitedFollowUpView } from './UnlimitedFollowUpView';
import { useSidebarVisibility } from '../../contexts/SidebarVisibilityContext';
import { useEffect } from 'react';
import { TemplatesSidebar } from '../Shared/TemplatesSidebar';

/**
 * Top-level Unlimited page component. Sets up the provider hierarchy:
 * DiffitBooks > UnlimitedModals > Unlimited > Router
 *
 * The sign-in modal is no longer among them: it is the app-wide instance Base mounts,
 * reached through the same useSignInModal() this page's hooks already call.
 */
export const Unlimited = () => (
  <DiffitBooksProvider>
    <UnlimitedModalsProvider>
      <UnlimitedProvider>
        <UnlimitedRouter />
      </UnlimitedProvider>
    </UnlimitedModalsProvider>
  </DiffitBooksProvider>
);

const UnlimitedRouter = () => {
  const { followUp, input } = useUnlimitedContext();
  const { showFollowUp, currentQuestion } = followUp;
  const { isLoadingQuestions, isCreating } = input;
  const { setSidebarHidden = () => {} } = useSidebarVisibility();

  useEffect(() => {
    const shouldHide = isLoadingQuestions || isCreating || (showFollowUp && !!currentQuestion);
    setSidebarHidden(shouldHide);
    return () => setSidebarHidden(false);
  }, [isLoadingQuestions, isCreating, showFollowUp, currentQuestion, setSidebarHidden]);

  if (showFollowUp && currentQuestion) {
    return <UnlimitedFollowUpView />;
  }

  return (
    <>
      {/* portals into AppSidebar's slot when the new nav flag is on */}
      <TemplatesSidebar />
      <UnlimitedMainView />
    </>
  );
};
